export default "__VITE_ASSET__BmoP6VWY__"